// Wei Care company facts — the only place they live in the frontend.
// Source: backend/docs/projects/weicare/BRAND.md. Add nothing that isn't there.
export const COMPANY = {
  tradingName: 'Wei Care',
  legalName: 'Weicare Pty Ltd',
  abn: '40 643 964 121',
  location: '15 Monash Street, Clermont QLD 4721',
  phone: '+61 420 162 243',
  phoneHref: 'tel:+61480804640',
  email: 'info@weicarehome.com',
  website: 'https://weicarehome.com',
};
